import { grantFullGame } from '../meta/unlock';
import { onAppShown } from '../platform/native';
import { onFullGamePurchased, ownsFullGame } from '../platform/purchases';
import { saves } from './records';

/**
 * Keeps the save's full-game flag in step with the store (docs/MONETIZATION.md): asked at boot
 * and whenever the app comes back (a code redeemed in the App Store meanwhile), and told of
 * purchases that land while it runs. Only ever grants: a store that can't be reached (offline)
 * or a refund never takes the game away from a player mid-play.
 *
 * Dev builds play the whole game (the DEV tab, e2e) unless `?free` asks for the free part.
 */
export function initFullGame(): void {
  if (import.meta.env.DEV) {
    const free = new URLSearchParams(location.search).has('free');
    saves().update((s) => {
      if (free) s.fullGame = false;
      else grantFullGame(s);
    });
    return;
  }
  const sync = async () => {
    if (saves().save.fullGame) return;
    if (await ownsFullGame()) saves().update(grantFullGame);
  };
  void sync();
  onAppShown(() => void sync());
  onFullGamePurchased(() => {
    if (!saves().save.fullGame) saves().update(grantFullGame);
  });
}
